import { PositionsScreenRow } from 'app/models/positions-screen-row'
import { createReducer } from 'app/state/utils'
import * as types from './types'

export interface PositionsScreenState {
  rows: PositionsScreenRow[]
  isLoading: boolean
}

const initialState: PositionsScreenState = { rows: [], isLoading: false }

/**
 * The Positions grid's rows, as the server projects them (ADR_LOS-030). A
 * read-only grid: nothing on the page writes a position, so there is no
 * write to patch and no generation to keep — the page reads on mount.
 */
const positionsScreenReducer = createReducer(initialState)({
  [types.GET_POSITIONS_SCREEN]: (state: PositionsScreenState, action: { payload: PositionsScreenRow[] }) => ({
    ...state,
    rows: action.payload,
  }),
  [types.START_LOADING_POSITIONS_SCREEN]: (state: PositionsScreenState) => ({ ...state, isLoading: true }),
  [types.STOP_LOADING_POSITIONS_SCREEN]: (state: PositionsScreenState) => ({ ...state, isLoading: false }),
})

export default positionsScreenReducer
